import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'AnalyticsPage.WorkshopNotifications.Title',
    defaultMessage: 'Builder Notification Analytics'
  },
  noActivityMetrics: {
    id: 'AnalyticsPage.WorkshopNotifications.noActivityMetrics.Message',
    defaultMessage: 'No Activity Data for the Date Range'
  },
  cardTitle: {
    id: 'AnalyticsPage.WorkshopNotifications.Card.Title',
    defaultMessage: 'Notification Statistics'
  },
  cardSubTitle: {
    id: 'AnalyticsPage.WorkshopNotifications.Card.SubTitle',
    defaultMessage: 'Monitor and analyze adoption and usage across the notification'
  },
  close: {
    id: 'AnalyticsPage.WorkshopNotifications.Card.Close',
    defaultMessage: 'Close'
  },
  loading: {
    id: 'AnalyticsPage.WorkshopNotifications.Loading',
    defaultMessage: 'Loading...'
  },
  errorTitle: {
    id: 'AnalyticsPage.WorkshopNotifications.UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'AnalyticsPage.WorkshopNotifications.UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  missingContent: {
    id: 'AnalyticsPage.WorkshopNotifications.MetricSection.MissingContent',
    defaultMessage: 'MISSING CONTENT'
  },
  back: {
    id: 'AnalyticsPage.WorkshopNotifications.Back',
    defaultMessage: 'Back to App Instance'
  },
  exportCSV: {
    id: 'Export.CSV',
    defaultMessage: 'Export CSV'
  }
})
